import React from "react";
import { redirect, useLocation } from "react-router-dom";
import PaseMedico from "./PaseMedico";

const PaseMedicoPage = () => {
    const location = useLocation();
    const [verPaseMedico, setVerPaseMedico] = React.useState(false);

    // nos envian el estado si es approved o rejected para mostrar el pase médico con la información correspondiente
    const [status, setStatus] = React.useState("");

    // recibimos de este lado el idPaseMedico como referencia para mostrar el pase médico
    const [reference, setReference] = React.useState(null);

    React.useEffect(() => {
        const params = new URLSearchParams(location.search);
        const statusParam = params.get("nbResponse");
        const referenceParam = params.get("referencia");

        if (statusParam) {
            setStatus(statusParam);
            if (statusParam.toLowerCase() === "aprobado") {
                setVerPaseMedico(true);
            } else {
                setVerPaseMedico(false);
            }
        }

        if (referenceParam) setReference(referenceParam);
    }, [location.search]);


    return (
        <>
        {verPaseMedico ? (
            <PaseMedico idPaseMedico={reference} verPaseMedico={verPaseMedico} setverPaseMedico={setVerPaseMedico} />
        ) : (
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "100vh" }}>
                <h1>Lo sentimos, ha ocurrido un error al procesar tu pago, por favor intenta nuevamente.</h1>
            </div>
        )}
        </>
    );
};

export default PaseMedicoPage;